import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/context/LangContext";

export default function PaymentSuccess() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setStatus("done"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sid}`);
        if (r.data.payment_status === "paid") { setStatus("done"); return; }
        if (["expired", "failed"].includes(r.data.payment_status)) { setStatus("failed"); return; }
      } catch (e) { console.error("Payment status poll error:", e); }
      if (tries++ < 8) setTimeout(poll, 2000);
      else setStatus("done");
    };
    poll();
  }, [params]);

  return (
    <div data-testid="payment-success" className="max-w-lg mx-auto px-4 pt-32 pb-32 text-center">
      {status === "checking" ? (
        <><Loader2 className="w-10 h-10 text-[#C6899E] mx-auto mb-6 animate-spin" />
          <p className="text-[#8C7E83]">…</p></>
      ) : (
        <>
          <CheckCircle2 className="w-14 h-14 text-[#C6899E] mx-auto mb-6" />
          <h1 className="font-serif text-4xl mb-3">{t("payment_success")}</h1>
          <p className="text-[#8C7E83] mb-8">{t("payment_success_desc")}</p>
          <Link to="/" className="inline-flex bg-[#C6899E] text-[#4A2233] rounded-full px-7 py-3 text-sm uppercase tracking-[0.15em] hover:bg-[#B4718C] transition-colors">
            {t("go_home")}
          </Link>
        </>
      )}
    </div>
  );
}
